import * as ApiUtils from "../ApiUtils";
import { openNotification } from "../Components/Common/Notification";

export const verifyErrorAndShowMessage = (input: any, errorMessage: string) => {
  if (input.hasOwnProperty("sessionToken"))
    saveSessionToken(input.sessionToken);
  if (!input) {
    openNotification("error", errorMessage);
    return false;
  } else if (input.hasOwnProperty("errorCode")) {
    openNotification("error", input.errorSummary);
    return false;
  } else if (input.hasOwnProperty("error")) {
    openNotification("error", input.error);
    return false;
  }
  return true;
};

export const getSessionToken = () => {
  return !!sessionStorage.getItem("sessionToken")
    ? sessionStorage.getItem("sessionToken")
    : null;
};

export const saveSessionToken = (sessionToken: string) => {
  sessionStorage.setItem("sessionToken", sessionToken);
};

export const setPushSessionToken = (sessionToken: string) => {
  sessionStorage.setItem("pushSessionToken", sessionToken);
};


export const getPushSessionToken = () => {
  return sessionStorage.getItem("pushSessionToken");
};

export const clearSessionStorage = () => {
  sessionStorage.clear();
};

export const setCurrentPage = (pathname: string) => {
  sessionStorage.setItem("page-info", pathname);
};

export const getCurrentPage = () => {
  return sessionStorage.getItem("page-info") as string;
};

export const componentMountCheck = (route?: string) => {
  if (route !== window.location.pathname) {
    openNotification("info", ApiUtils.genericErrorMsg);
    window.location.href = "/";
  }
};

export const getAlertSummary = (errorResponse: any) => {
  var errorMsg = "";
  if (
    !!errorResponse.hasOwnProperty("errorCauses") &&
    errorResponse["errorCauses"].length > 0
  ) {
    for (var i = 0; i < errorResponse["errorCauses"].length; i++) {
      errorMsg += errorResponse["errorCauses"][i]["errorSummary"];
    }
    return errorMsg;
  }

  if (!errorMsg) return errorResponse.errorSummary;
};


export const getImageBeacon = (item: any): string => {
  if (item.factorType === ApiUtils.HOTPFactorType) {
    return "../../hotpFactor_38x38.png";
  }

  if (item.factorProvider === ApiUtils.DUOFactorProvider) {
    return "../../duo_70x70.e2baf65d97a5d6f2c083e14d4717ccf4.png";
  }

  if (
    (item.factorType === ApiUtils.oktaPushFactorType ||
      item.factorType === ApiUtils.oktaTOTPFactorType) &&
    item.factorProvider === ApiUtils.oktaPushFactorProvider
  ) {
    return "../../oktaVerify_70x70.00aa672ea67517ca19e2b110d650e03f.png";
  }

  if (item.factorType === ApiUtils.smsFactorType) {
    return "../../sms_70x70.30e2a05096c1192ff1f96cf11acfdf17.png";
  }

  if (item.factorType === ApiUtils.googleTOTPFactorType) {
    return "../../googleAuth_38x38.750e8cb4f65b1d8f3a844baa0ac99454.png";
  }

  if (
    item.factorType === ApiUtils.callFactorType ||
    item.factorType === ApiUtils.voiceFactorType
  ) {
    return "../../voicecall_70x70.b651a1f230ee1aea148c87773d533faf.png";
  }

  if (item.factorType === ApiUtils.emailFactorType) {
    return "../../email_38x38.b7ac950da2ba64f5886b21c9f97c7cc8.png";
  }

  if (
    item.factorType === ApiUtils.yubicoTOTPHardwareType &&
    item.factorProvider === ApiUtils.yubicoTOTPHardwareProvider
  ) {
    return "../../yubico@2x.png";
  }

  if (item.factorProvider === ApiUtils.RSATokenFactorProvider) {
    return "../../rsa_70x70.e01fbd6241936eeb9cdf15c72cde49e9.png";
  }

  if ([ApiUtils.CREDENTIFactorProvider, ApiUtils.authentifaceFactorProvider].includes(item.factorProvider)) {
    return "../../credenti-favicon.png";
  }

  return "../../question_38x38.8453db9ea592a3015add7fb268491a3b.png";
};
